export const LANDING_PAGE = 'PB_LANDING_PAGE';
export const FLYER_PAGE = 'PB_FLYER_PAGE';
export const VDP_PAGE = 'PB_VDP_PAGE';
export const CARD_PAGE = 'PB_CARD_PAGE';
export const LEGAL_PAGE = 'PB_LEGAL_PAGE';
export const ERROR_PAGE = 'PB_ERROR_PAGE';

export const PATH_TYPE_MAP = {
  '/card': CARD_PAGE,
  '/cards': CARD_PAGE,
  '/category': CARD_PAGE,
  '/group': CARD_PAGE,
  '/section': CARD_PAGE,

  '/flyer': FLYER_PAGE,
  
  '/vdp': VDP_PAGE,

  '/birthday': LANDING_PAGE,
  '/christmas-cards': LANDING_PAGE,
  '/holiday': LANDING_PAGE,
  '/home': LANDING_PAGE,
  '/online-invitations': LANDING_PAGE,
  '/professional-holiday': LANDING_PAGE,
  '/upload-your-own': LANDING_PAGE,
  '/wedding': LANDING_PAGE,
  '/ystationery': LANDING_PAGE,

  '/terms-of-service': LEGAL_PAGE,
  '/privacy-policy': LEGAL_PAGE,
  '/cookie-policy': LEGAL_PAGE,
};

const routes = {
  // Landing Pages
  '/': {
    title: 'Home',
    serverPath: '/home',
    type: LANDING_PAGE,
  },
  '/birthday': {
    title: 'Birthday',
    serverPath: '/birthday',
    type: LANDING_PAGE,
  },
  '/christmas-cards': {
    title: 'Christmas Cards',
    serverPath: '/christmas-cards',
    type: LANDING_PAGE,
  },
  '/cookie-policy': {
    title: 'Cookie Policy',
    serverPath: '/cookie-policy',
    type: LANDING_PAGE,
  },
  '/flyer': {
    title: 'Flyer',
    serverPath: '/flyer',
    type: FLYER_PAGE,
  },

  '/holiday': {
    title: 'Holiday',
    serverPath: '/holiday',
    type: LANDING_PAGE,
  },
  '/online-invitations': {
    title: 'Online Invitations',
    serverPath: '/online-invitations',
    type: LANDING_PAGE,
  },
  '/privacy-policy': {
    title: 'Privacy Policy',
    serverPath: '/privacy-policy',
    type: LANDING_PAGE,
  },
  '/professional-holidays': {
    title: 'Professional Holiday',
    serverPath: '/professional-holidays',
    type: LANDING_PAGE,
  },
  '/terms-of-service': {
    title: 'Terms of Service',
    serverPath: '/terms-of-service',
    type: LANDING_PAGE,
  },

  '/upload-your-own': {
    title: 'Upload Your Own',
    serverPath: '/upload-your-own',
    type: LANDING_PAGE,
  },
  '/wedding': {
    title: 'Wedding',
    serverPath: '/wedding',
    type: LANDING_PAGE,
  },
  '/ystationery': {
    title: 'Y Stationery',
    serverPath: '/ystationery',
    type: LANDING_PAGE,
  },
  '/professional-invitations': {
    title: 'Professional Invitations',
    serverPath: '/professional-invitations',
    type: LANDING_PAGE,
  },

  // Paper Browser Pages
  '/cards(/)': {
    title: 'All Cards',
    serverPath: '/cards',
    type: CARD_PAGE,
    paperBrowser: true,
  },
  '/cards/group/:slug': {
    title: 'View Group',
    serverPath: '/group',
    type: CARD_PAGE,
    paperBrowser: true,
  },
  '/cards/section/:slug': {
    title: 'View Section',
    serverPath: '/section',
    type: CARD_PAGE,
    paperBrowser: true,
  },
  '/cards/category/:slug': {
    title: 'View Category',
    serverPath: '/category',
    type: CARD_PAGE,
    paperBrowser: true,
  },
  '/cards/card/:slug': {
    title: 'Card Page',
    serverPath: '/card',
    type: CARD_PAGE,
    paperBrowser: true,
  },

  // Flyer Pages
  '/flyer/vibes/:slug': {
    title: 'Vibe Detail Page',
    serverPath: '/vdp',
    type: VDP_PAGE,
  },
};

export default routes;